import {
    CircularProgress,
    createStyles,
    Paper,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React from "react";
import * as FullScreenCss from "../../styles/FullScreenCss";
import SectionBanner from "../shared/SectionBanner";
import SkeletonBox from "./SkeletonBox";

type FullscreenLoaderProps = WithStyles<
    typeof styles | typeof FullScreenCss.styles
> & {
    hideTempBody?: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        overlaySpinner: {
            left: "50%",
            msTransform: "translate(-50%, -50%)",
            position: "absolute",
            textAlign: "center",
            top: "50%",
            transform: "translate(-50%, -50%)"
        },
        overlayText: { color: theme.palette.secondary.contrastText },
        section: {
            [theme.breakpoints.down("xs")]: {
                paddingLeft: theme.bodyContent.mobilePadding,
                paddingRight: theme.bodyContent.mobilePadding
            },
            backgroundColor: theme.palette.background.paper,
            paddingLeft: theme.bodyContent.desktopPadding,
            paddingRight: theme.bodyContent.desktopPadding,
            position: "relative",
            width: "100%"
        },
        tempBodyPaper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column"
        },
        tempBodySection: {
            [theme.breakpoints.down("xs")]: {
                paddingBottom: theme.bodyContent.mobilePadding,
                paddingLeft: theme.bodyContent.mobilePadding,
                paddingRight: theme.bodyContent.mobilePadding,
                paddingTop: theme.bodyContent.mobilePadding
            },
            alignItems: "center",
            backgroundColor: theme.palette.background.dark,
            display: "flex",
            flexDirection: "column",
            paddingBottom: theme.bodyContent.desktopPadding,
            paddingLeft: theme.bodyContent.desktopPadding,
            paddingRight: theme.bodyContent.desktopPadding,
            paddingTop: theme.bodyContent.desktopPadding,
            position: "relative",
            width: "100%"
        },
        ...FullScreenCss.styles(theme)
    });

function FullscreenLoader({ classes, hideTempBody }: FullscreenLoaderProps) {
    return (
        <>
            <div
                className={classes.fullScreenOverlay}
                data-testid="fullscreenLoader"
            >
                <div className={classes.overlaySpinner}>
                    <CircularProgress />
                    <Typography
                        className={classes.overlayText}
                        component="h5"
                        variant="h5"
                    >
                        Loading
                    </Typography>
                </div>
            </div>
            {!hideTempBody && (
                <Paper className={classes.tempBodyPaper} elevation={2}>
                    <SectionBanner leftSideText="Loading..." />
                    <div className={classes.tempBodySection}>
                        <SkeletonBox />
                        <SkeletonBox />
                        <SkeletonBox />
                    </div>
                </Paper>
            )}
        </>
    );
}

export default withStyles(styles)(FullscreenLoader);
